import { MenuItem, Select } from "@mui/material";
import { useIsCredentialRequirementConfigurationEnabled } from "@src/appV2/FeatureFlags/useIsCredentialRequirementConfigurationEnabled";
import { FormFieldController } from "@src/appV2/PlacementCandidates/components/FormFieldController";
import { type Control, type UseFormSetValue, useWatch } from "react-hook-form";

import { isAllowRequiredForBooking } from "../isAllowRequiredForBooking";
import { Domain, type RequirementMappingFormValues } from "../types";

interface DomainSelectFieldProps {
  disabled?: boolean;
  control: Control<RequirementMappingFormValues>;
  setValue: UseFormSetValue<RequirementMappingFormValues>;
}

export function DomainSelectField(props: DomainSelectFieldProps) {
  const { control, disabled = false, setValue } = props;

  const isCredentialRequirementConfigurationEnabled =
    useIsCredentialRequirementConfigurationEnabled();

  const domainOptions = [
    { value: Domain.FLEX, label: "Flex" },
    { value: Domain.HIRING, label: "Hiring" },
  ];

  const mappingLevel = useWatch({ control, name: "level" });

  return (
    <FormFieldController
      name="domain"
      control={control}
      label="Domain"
      sx={{ mb: 2 }}
      render={(field) => (
        <Select
          {...field}
          labelId="domain-select-label"
          disabled={disabled}
          value={field.value}
          onChange={(event) => {
            field.onChange(event);

            if (
              !isAllowRequiredForBooking({
                domain: event.target.value as Domain,
                mappingLevel,
                isCredentialRequirementConfigurationEnabled,
              })
            ) {
              setValue("requiredForBooking", false);
            }
          }}
        >
          {domainOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      )}
    />
  );
}
